import React from 'react'
import { Link } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa6";

import File1 from "./../../assets/pdf/AvailabilityofCropsRabi2023-24.pdf";
import File2 from "./../../assets/pdf/AvailabilityofVegRabi2023-24.pdf";

const AvailabilityRabiSeeds = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Availability of Rabi Seeds </h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
      style={{ textAlign: "justify" }}
    >
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>
                  <span>S.No</span>
                </th>
                <th>
                  <span>Availability Of Seeds For Sale During Rabi 2022-23 Season</span>
                </th>
                
                <th>
                  <span>
                    Document{" "}
                    <span style={{ fontSize: "12px" }}>(pdf, English)</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>1</span>
                </td>
                <td>
                  <strong>
                  Crop - Wheat, Gram, Mustard & Barley Seed
                  </strong>
                </td>
                
                <td className="text-center align-middle">
                  <Link to={File1} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>

              <tr>
                <td>
                  <span>2</span>
                </td>
                <td>
                  <strong>
                  Vegetables
                  </strong>
                </td>
                
                <td className="text-center align-middle">
                  <Link to={File2} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
  
      
    </div>
    </div>
  )
}

export default AvailabilityRabiSeeds
